import {Component, EventEmitter, Injector, Input, OnDestroy, Output, ViewChild} from '@angular/core';
import {ModalFormComponentInterface} from '@interfaces/modal-form-component.interface';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {ModalComponent} from '@components/modal/modal.component';
import {ConclusionApiService} from '@api/conclusion.api.service';
import {UploadedFile} from '@interfaces/file.interface';
import {EventsService} from '@services/events.service';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';

@Component({
    selector: 'app-element-conclusion-scan-form-modal',
    templateUrl: './conclusion-scan-form-modal.component.html',
})
export class ConclusionScanFormModalComponent extends FrontendFormComponent implements ModalFormComponentInterface, OnDestroy {

    public afterSaveMessage = NotyMessagesEnum.conclusionScanUpdatedMessage;

    @ViewChild(ModalComponent) modal: ModalComponent;

    public modalTitle = 'Скан заключения';

    public fileToPreview: UploadedFile;

    form = this._fb.group({
        scan: this._fb.group({}),
    });

    @Input() conclusionId: number;

    @Output() saved = new EventEmitter<UploadedFile>();

    constructor(
        injector: Injector,
        public formService: ConclusionApiService,
        private events: EventsService,
    ) {
        super(injector);
    }

    get saveUrl() {
        return this.formService.getScanFormPath(this.conclusionId);
    }

    init() {

    }

    onModalClose() {
        this.saved.emit();
    }

    show(conclusionId?: number, scan?: UploadedFile) {

        this.conclusionId = conclusionId;

        if (scan) {
            this.fileToPreview = scan;
        }

        this.modal.open();
    }

    afterSave() {
        super.afterSave();
        this.saved.emit(this.form.value.scan);
        this.modal.close();
    }

    removeScan() {
        this.events.showConfirm({
            title: 'Вы уверены, что хотите удалить файл скана?',
            confirmButtonTitle: 'Удалить',
        }).subscribe(() => {
            this.formService.delete({
                url: this.formService.getScanFormPath(this.conclusionId),
            }).subscribe(() => {
                this.saved.emit(null);
                this.modal.close();
                this.events.showNoty({
                    type: 'success',
                    content: NotyMessagesEnum.conclusionScanRemovedMessage,
                });
            }, () => {
                this.events.showNoty({
                    type: 'error',
                    content: NotyMessagesEnum.conclusionScanRemovedFailMessage,
                });
            });
        }, () => {});
    }

    ngOnDestroy() {
        this.saved.emit(null);
        this.saved.complete();
    }
}
